import { BUSINESS_USER_APP_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { IBussinessAppUserRepository } from "features/businessAppUserManagement/domain/repositories/IBussinessAppUserRepository";
import { injectable } from "tsyringe";
import { BussinessAppUserRequestModel } from "./model/BussinessAppUserRequestModel";
import { BussinessAppUserResponseModel } from "./model/BussinessAppUserResponseModel";

@injectable()
export class BussinessAppUserImpl implements IBussinessAppUserRepository {
  async getList(
    params: BussinessAppUserRequestModel,
  ): Promise<ListBaseApiResponseModel<BussinessAppUserResponseModel>> {
    return await client?.get(BUSINESS_USER_APP_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: BussinessAppUserRequestModel,
  ): Promise<BaseApiResponseModel<BussinessAppUserResponseModel>> {
    return await client?.get(BUSINESS_USER_APP_MANAGEMENT.DETAIL, params);
  }

  async resetOtpUser(
    phone: string,
  ): Promise<
    BaseApiResponseModel<{ phone?: string; deleteOtpCount?: number }>
  > {
    return await client?.get(BUSINESS_USER_APP_MANAGEMENT.RESET_OTP, { phone });
  }
}
